export const LANDINGPAGE = "/";
export const MAINPAGE = "/home";
export const SIGNUPPAGE = "/auth/signup";
export const LOGINPAGE = "/auth/login";
export const PROFILE = "/profile";
export const GAMEPAGE = "/game";
export const QUESTIONSPAGE = "/questions";
export const LEADERBOARDS ="/leaderboard";

//leaderboards page
